import { Navigate, useLocation } from 'react-router-dom'

import { ErrorState } from '@/components/feedback/ErrorState'
import { Loading } from '@/components/feedback/Loading'
import { NotFoundPage } from '@/features/not-found/NotFoundPage'
import { ChartReportView } from '@/features/report/ChartReportView'
import { DashboardReportView } from '@/features/report/DashboardReportView'
import { ReconcileReportView } from '@/features/report/ReconcileReportView'
import { TableReportView } from '@/features/report/TableReportView'
import { useReports } from '@/hooks/use-cube-meta'

/**
 * Tüm rapor route'larının tek girişi: adres, Cube meta'sındaki `route` ile eşlenir.
 * Kullanıcının izni olmayan rapor meta'da hiç yoktur, dolayısıyla burada
 * "bulunamadı" düşer — veri erişimini zaten Cube'ün `access_policy`'si keser.
 */
export function ReportPage() {
  const { pathname } = useLocation()
  const reports = useReports()

  if (reports.isLoading) return <Loading rows={8} />
  if (reports.isError) {
    return <ErrorState error={reports.error} onRetry={() => void reports.refetch()} />
  }
  const report = reports.data?.find((item) => item.route === pathname)
  if (!report) return <NotFoundPage />

  return (
    // `key`: rapordan rapora geçişte hiçbir yerel durum taşınmasın.
    <div key={report.view} className="flex flex-col gap-4">
      {/* Başlık üst çubuktaki breadcrumb'ta görünür; burada yalnız ekran okuyucu için. */}
      <h1 className="sr-only">{report.title}</h1>
      {report.layout === 'table' ? (
        <TableReportView report={report} />
      ) : report.layout === 'chart' ? (
        <ChartReportView report={report} />
      ) : report.layout === 'reconcile' ? (
        <ReconcileReportView report={report} />
      ) : (
        <DashboardReportView report={report} />
      )}
    </div>
  )
}

/** Kök adres: kullanıcının görebildiği ilk rapor; hiç yoksa sistem ekranı. */
export function ReportIndexRedirect() {
  const reports = useReports()
  if (reports.isLoading) return <Loading rows={8} />
  return <Navigate to={reports.data?.[0]?.route ?? '/sistem'} replace />
}
